module.exports = __webpack_public_path__ + "img/限额办卡前.5667fcca.png";